import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PublicNav from '../screens/landing-site/components/public-nav';
import Footer from '../screens/landing-site/components/footer';
const PublicLayout = ({ children }) => (_jsxs("div", { className: "public-page", children: [_jsx(PublicNav, {}), children, _jsx(Footer, {})] }));
export default PublicLayout;
